import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GaleryComponent } from './galery.component';
import {DragScrollComponent} from "ngx-drag-scroll";

@NgModule({
  declarations: [
    GaleryComponent
  ],
    imports: [
        CommonModule,
        DragScrollComponent,
    ],
  exports: [
    GaleryComponent
  ]
})
export class GalleryModule {
}
